module.exports = __webpack_public_path__ + "img/ic_homestay_apply_item_img1.5819b992.png";